// Yachangu Driver V2 design tokens — single source for spacing/typography/color
// Keep numbers tabular for live-updating metrics.
export const TOKENS = {
  // Brand
  primary: '#16A34A',         // Yachangu green
  primaryDark: '#15803D',
  primaryTint: '#DCFCE7',
  accentRose: '#E11D48',
  surge: '#F59E0B',

  // Surfaces
  surfaceFrosted: 'bg-white/85 backdrop-blur-md',
  surfaceCard: 'bg-white',
  surfaceMuted: 'bg-gray-50',

  // Radii
  radiusLg: 'rounded-3xl',    // big floating cards
  radiusMd: 'rounded-2xl',    // standard cards
  radiusPill: 'rounded-full',

  // Shadows
  shadowFloat: 'shadow-[0_8px_24px_rgba(0,0,0,0.12)]',
  shadowSoft: 'shadow-[0_4px_12px_rgba(0,0,0,0.08)]',
};

// Format helpers
export const formatMWK = (n) => `K${(Number(n) || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

export const formatHm = (totalSeconds) => {
  const s = Math.max(0, Number(totalSeconds) || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h <= 0) return `${m}m`;
  return `${h}h ${m.toString().padStart(2, '0')}m`;
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 5) return 'Good night';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
};
